export const getAntd = () =>{
    return typeof window.antd === "undefined" ? {} : window.antd;
}

export const getEcCom = () =>{
    return typeof window.ecCom === "undefined" ? window.ecComSmall : window.ecCom;
}

export const getComsMobx = () =>{
    return typeof window.comsMobx === "undefined" ? {} : window.comsMobx;
}

export const getLabel = (...args) =>{
    const { WeaLocaleProvider } = getEcCom();
    return WeaLocaleProvider.getLabel(...args);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/convert.js